import React, { useEffect } from 'react';
import styled from 'styled-components';
import AddPhotoTile from './AddPhotoTile';
import { analyticsTrackEvent } from '../../../core/analytics';
import { Events, Actions } from './util/analytics';
import { safeGet } from '../../../core/util/object';
import { isEmpty } from '../../../core/util/empty';
import { isNativeApp } from '../../../core/util/device';
import Observer from '../../SolvPatternLibrary/Profilers/Observer';

const Root = styled.div.withConfig({ componentId: 'sc-1d0nwv5-0' })``;

const Image = styled.img.withConfig({ componentId: 'sc-1d0nwv5-1' })`
  margin: 5px;
  width: 80px;
  height: 80px;
  border-radius: 20%;
`;

const ActionContainer = styled.div.withConfig({ componentId: 'sc-1d0nwv5-2' })`
  display: flex;
  flex-direction: row;
  margin: 0 -8px;
`;

const NUM_IMAGES_PER_VISIT = 3;

type Props = {
  accountId?: string;
  booking?: any;
  bookingImages?: any;
  fetchBookingImages?: (...args: any[]) => any;
  saveFile?: (...args: any[]) => any;
  subtitle?: string;
  userProfileId?: string;
  sessionTrackingProperties?: any;
};

const VisitPhotos = (props: Props) => {
  const trackClick = (action: any) => () => {
    const { accountId, bookingImages, userProfileId } = props;

    const numberOfPhotosUploaded = safeGet(bookingImages, [])('results')
      ? safeGet(bookingImages, [])('results').length
      : 0;
    analyticsTrackEvent(Events.PVS_PHOTO, {
      accountId,
      action,
      numberOfPhotosUploaded,
      userProfileId,
    });
  };

  const getImageArray = () => {
    // copy array by value

    const images = safeGet(props, [])('bookingImages.results');
    const arr = isEmpty(images) ? [] : images.slice(0, 3);
    while (arr.length < NUM_IMAGES_PER_VISIT) {
      arr.push(0);
    }

    return arr;
  };

  const getImage = (i: any, res: any) => {
    if (isNativeApp(safeGet(props.sessionTrackingProperties)('userAgent'))) {
      return (
        <div key={i} onClick={trackClick(Actions.CLICK_VIEW_FILE)}>
          <Image alt="Post Visit Summary Photo" src={res.image_url} />
        </div>
      );
    }

    return (
      <div key={i} onClick={trackClick(Actions.CLICK_VIEW_FILE)}>
        <a href={res.image_url} target="_blank">
          <Image alt="Post Visit Summary Photo" src={res.image_url} />
        </a>
      </div>
    );
  };

  const handleObserverChange = (action: any) => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    props.fetchBookingImages();
    const { accountId, bookingImages, userProfileId } = props;

    const numberOfPhotosUploaded = safeGet(bookingImages, [])('results')
      ? safeGet(bookingImages, [])('results').length
      : 0;

    analyticsTrackEvent(Events.PVS_PHOTO, {
      accountId,
      action,
      numberOfPhotosUploaded,
      userProfileId,
    });
  };

  const handleImageSelect = (event: any) => {
    const files = [...event.target.files];
    // @ts-expect-error ts-migrate(2365) FIXME: Operator '>' cannot be applied to types 'boolean' ... Remove this comment to see the full error message
    if (!files || !files.length > 0) return;
    const imageFile = files[0];

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    props.saveFile(imageFile);
  };

  const imageArr = getImageArray();
  return (
    <Root>
      <Observer handleSawComponent={() => handleObserverChange(Actions.SEE_PHOTO_UPLOAD_CTA)}>
        <ActionContainer>
          {imageArr.map((res: any, i: any) =>
            res === 0 ? (
              <div key={i} onClick={trackClick(Actions.CLICK_UPLOAD_FILE)}>
                <AddPhotoTile handleImageSelect={handleImageSelect} />
              </div>
            ) : (
              getImage(i, res)
            )
          )}
        </ActionContainer>
      </Observer>
    </Root>
  );
};

export default VisitPhotos;
